export const BACKEND_URL = "https://backend.sauron.6thlabs.com";